import React, { useState } from "react";
import axios from "axios";
import { getApiBase } from "../apiBase";
import { buildPluginsHeader } from "./registry";

const AUTH_TOKEN_KEY = "projectBoardAuthToken";

function authHeaders() {
  const h = { ...buildPluginsHeader() };
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) h.Authorization = `Bearer ${token}`;
  } catch {
    /* ignore */
  }
  return h;
}

export default function CommercialDbResetPanel() {
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [typed, setTyped] = useState("");

  async function runReset() {
    if (typed !== "RESET") {
      setError('Type RESET to confirm.');
      return;
    }
    setBusy(true);
    setError("");
    setStatus("");
    try {
      const base = getApiBase();
      const res = await axios.post(
        `${base}/admin/commercial/reset-database`,
        { confirm: true },
        { headers: authHeaders() }
      );
      setStatus(res.data?.message || "Database reset complete.");
      setTyped("");
      try {
        const bc = new BroadcastChannel("project-board-sync");
        bc.postMessage({ type: "projects-reset" });
        bc.close();
      } catch {
        /* ignore */
      }
    } catch (err) {
      setError(err?.response?.data?.error || err?.message || "Reset failed.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="plugins-card" style={{ padding: "1rem 1.25rem", marginBottom: "1rem" }}>
      <h3 className="plugins-card-name" style={{ marginTop: 0 }}>
        Commercial database reset
      </h3>
      <p className="plugins-card-desc">
        Deletes <strong>all projects</strong>, comments, field files, and domain payloads. Reseeds
        workflow phases (Sales → Accounting, including Drafting). Irreversible unless you have an
        archive backup.
      </p>
      <label style={{ display: "block", marginBottom: 8, fontSize: 13 }}>
        Type <code>RESET</code> to confirm
        <input
          type="text"
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          disabled={busy}
          className="email-triggers-select"
          style={{ display: "block", marginTop: 4, maxWidth: 200 }}
          autoComplete="off"
        />
      </label>
      <button
        type="button"
        className="email-triggers-button"
        disabled={busy || typed !== "RESET"}
        onClick={runReset}
        style={{ borderColor: "#b91c1c", color: "#b91c1c" }}
      >
        {busy ? "Resetting…" : "Reset database for commercial schema"}
      </button>
      {status ? (
        <p className="email-triggers-muted" role="status" style={{ marginTop: 8 }}>
          {status}
        </p>
      ) : null}
      {error ? (
        <p className="email-triggers-muted" role="alert" style={{ marginTop: 8, color: "#b45309" }}>
          {error}
        </p>
      ) : null}
    </section>
  );
}
